export default class ValueType {
  public static Percent = 'percent'
  public static Amount = 'amount'
  public static Static = 'static'
}
